var chunkToChildrenMap = {
	"25284": [
		5444,
		37717
	],
	"77195": [
		5444
	],
	"78319": [
		5444,
		37717
	],
	"79410": [
		5444
	],
	"95896": [
		5444
	],
	"99524": [
		5444,
		37717
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));